import { createBlockheadClassName } from 'utils/classnames';

export const HORIZONTAL_PADDING = '17px';
export const SOCIAL_BUTTON_LOGO_CONTAINER_CLASSNAME = createBlockheadClassName(
  'SocialButton',
  'Icon',
);
